import { render, staticRenderFns } from "./VinculacionDePostulantes.vue?vue&type=template&id=717a2c8a&scoped=true"
import script from "./VinculacionDePostulantes.vue?vue&type=script&lang=js"
export * from "./VinculacionDePostulantes.vue?vue&type=script&lang=js"
import style0 from "./VinculacionDePostulantes.vue?vue&type=style&index=0&id=717a2c8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717a2c8a",
  null
  
)

export default component.exports